import { useEffect } from 'react';
import { BACKEND_URL } from '../utils/backendUrl';

/**
 * EMZI NEXUS — Public SSO Launch Endpoint (frontend-side bridge).
 *
 * The Nexus Notification Hub launches users at
 *   https://emzi.example.com/sso/nexus?token=<JWT>&return_to=<URL>
 * (no `/api/` prefix because Hub-side configuration is fixed).
 *
 * Kubernetes ingress only routes `/api/*` to the backend, so this path
 * naturally lands on the React app. We immediately forward the browser
 * to the real backend endpoint `${BACKEND_URL}/api/sso/nexus?…` which
 * does the JWT verification and 302-redirects to /sso/callback.
 *
 * Using `window.location.replace` so the bridge doesn’t pollute history.
 */

const SSONexusLaunch = () => {
  useEffect(() => {
    const search = window.location.search || '';
    const target = `${BACKEND_URL.replace(/\/$/, '')}/api/sso/nexus${search}`;
    window.location.replace(target);
  }, []);

  return (
    <div
      data-testid="sso-launch-bridge"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        color: '#0e67a2',
        fontSize: 14,
        fontWeight: 600,
      }}
    >
      Connecting to EMZI Nexus…
    </div>
  );
};

export default SSONexusLaunch;
